<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.57346 4.1808L15.5735 11.1808C16.1422 11.5789 16.1422 12.4212 15.5735 12.8193L5.57346 19.8193C4.91068 20.2832 4 19.8091 4 19V5.00003C4 4.19101 4.91068 3.71685 5.57346 4.1808ZM19 4.00003C19.5523 4.00003 20 4.44775 20 5.00003V19C20 19.5523 19.5523 20 19 20C18.4477 20 18 19.5523 18 19V5.00003C18 4.44775 18.4477 4.00003 19 4.00003ZM6 6.92069V17.0794L13.2562 12L6 6.92069Z"
    fill="currentColor"
  />
</svg>
